import React, { useState, useEffect } from 'react';
import {
  MotifButton, MotifFormField, MotifSearch,
  MotifIcon, MotifInput,
  MotifLabel,
  MotifBadge,
    MotifTooltip,
} from "@ey-xd/motif-react";
import FileTile from './FileTile'; // Adjust the path if necessary
import { deleteIcon, lockIcon, IconoirLockSlash, checkPwdIcon, eyeCloseIcon, eyeIcon, passwordCursorIcon, IconoirCheckIcon, closeIcon, IconoirCheckCircleIcon } from '../../common/MotifIcons';
import BreadcrumbNavigation from './BreadcrumbNavigation';
import PendingFileTile from './PendingFileTile';
import { apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getAccount } from "../../common/services/commonService";
import SmallCircleLoader from './SmallCircleLoader';
import { getDateTimeFormat, getUploadedByFormat } from '../../common/utility/utility';
import logger from "../../common/utils/logger";

const ProtectedFilesDisplay = ({ allProtectedFiles, baseURL, setAllProtectedFiles, passwords, setPasswords, navigateToFolder,
  currentPath, goBack, onClose, isClientEngagement, extractedFiles, rowData, handleRemoveFile, isCorrectPassword, setIsCorrectPassword,
  showError, setShowError, UPLOADID_GUID, triggerEngagementUpdate }) => {



  const [searchValue, setSearchValue] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState({});
  const [showValidatingLoader, setshowValidatingLoader] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedControlIds, setSelectedControlIds] = useState([]);
  const [isEngLevelPasswordVisible, setIsEngLevelPasswordVisible] = useState(false);
  const [engLevelPwd, setEngLevelPwd] = useState("");
  const [engLevelValidating, SetEngLevelValidating] = useState(false);
  const [engLevelValidationCheck, SetengLevelValidationCheck] = useState(false);
  const [totalFiles, SetTotalFiles] = useState(0);
  const [totalValidatedFiles, SetValidateFiles] = useState(0);

  // State to track which files are being deleted
  const [deletingFiles, setDeletingFiles] = useState(new Set());
  // State to track which folders are being deleted
  const [deletingFolders, setDeletingFolders] = useState(new Set());

  const togglePasswordVisibility = (folderPath) => {
    setIsPasswordVisible(prev => ({
      ...prev,
      [folderPath]: !prev[folderPath]
    }));
  };


  useEffect(() => {
    const term = searchValue?.toLowerCase() || '';
    setCurrentFolderContents(getCurrentFolderContents());
  }, [searchValue, currentPath, allProtectedFiles, extractedFiles]);

  useEffect(() => {
    allProtectedFiles.forEach(file => {
      setshowValidatingLoader[file.controlId] = false;
    });
  }, [allProtectedFiles]);

  // Clear deletion states when operation completes
  useEffect(() => {
    // Clear deletion states when allProtectedFiles changes (files removed)
    setDeletingFiles(new Set());
    setDeletingFolders(new Set());
  }, [allProtectedFiles]);

  const handleFolderUnlock = async (filePath) => {
    const normalizedFilePath = filePath.startsWith("/") ? filePath.slice(1) : filePath;
    const currentFolderName = normalizedFilePath.split("/").pop();
    const nestedProtectedFiles = allProtectedFiles.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      // const normalizedFile = f.filePath.startsWith("/") ? f.filePath.slice(1) : f.filePath;
      return normalizedFile.startsWith(normalizedFilePath);
    });

    const folderPasswordValue = passwords[filePath];
    const updatedPasswords = nestedProtectedFiles.reduce((acc, file) => {
      const isCorrect = isCorrectPassword[file.controlId];

      // Only update if password is incorrect or not checked yet
      if (isCorrect === false || isCorrect === undefined) {
        // Set file-level password
        acc[file.controlId] = folderPasswordValue;

        // Add folder path password(s)
        const normalized = file.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
        const parts = normalized.split('/');
        for (let i = 0; i < parts.length - 1; i++) {
          const folderPath = '/' + parts.slice(0, i + 1).join('/');
          acc[folderPath] = folderPasswordValue;
        }
      }

      return acc;
    }, {});

    setPasswords((prevPasswords) => ({
      ...prevPasswords,
      ...updatedPasswords,
    }));


    await Promise.all(
      nestedProtectedFiles.map(file => handleUnlockFile(file, folderPasswordValue, false))
    );


    //navigate to next level

    navigateToFolder(currentFolderName);

  };
  const validateZipFiles = async (jsonPayload) => {
    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/pending/zip/validate`,
        jsonPayload
      );

      return response.data;
    } catch (error) {
      // Handle the error
      logger.error("File validation failed:", error);
    }
  };
  const handleUnlockZipFile = async (file, zipPassword, isRootCall) => {

    const zipfileControlID = file.controlId;
    const password = zipPassword ? zipPassword : passwords[zipfileControlID];
    setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: true }));
    const jsonZipPayload = {
      controlId: parseInt(zipfileControlID, 10), // Convert controlId to integer
      eng_Password: String(password), // Ensure password is sent as a string
      engagementId: rowData?.engagementId,
      clientName: rowData?.clientName,
      userEmailId: getAccount()?.username,
      isPasswordValidated: false
    };

    try {


      const response = await validateZipFiles(jsonZipPayload);
      //   Check for invalid password response
      if (!response.isPasswordValid || typeof response === 'undefined') {
        setShowError(prev => ({ ...prev, [zipfileControlID]: true }));
        setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: false })); // Set correctness to false
        setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));

      } else {

        // new code for new process
        const mappedItems = response.zipFileContents.filter(item => item.isPasswordProtected).map((item, key) => ({
          fileName: item.filePath.split('/').pop(),
          filePath: item.filePath.replace(/\\/g, "/"),
          controlId: item.controlId,  // make sure this field exists in each item
        }));
        setAllProtectedFiles(prev =>
          [
            ...prev.filter(file => file.controlId !== zipfileControlID),
            ...mappedItems
          ]
        );

        setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));
        setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: true })); // Set correctness to true
        setShowError(prev => ({ ...prev, [zipfileControlID]: false }));

      }

    } catch (error) {
      logger.error("Error unlocking file:", error);
      setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: false }));
      setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));


    }
  };

  const handleUnlockFile = async (file, folderPasswordValue, isRootCall = true) => {
    const isZip = (file.filePath ? file.filePath : file.fileName).endsWith(".zip");
    const fileControlID = file.controlId;
    const password = folderPasswordValue ? folderPasswordValue : passwords[fileControlID];
    setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: true }));
    if (password === "" || password === undefined) {
      setShowError(prev => ({ ...prev, [fileControlID]: true }));
      setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false })); // Set correctness to false
      setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
      return
    }
    if (isZip) {
      await handleUnlockZipFile(file, password, isRootCall);
      return;
    }

    const jsonPayload = {
      controlId: parseInt(file.controlId, 10), // Convert controlId to integer
      eng_Password: String(password), // Ensure password is sent as a string
    };

    try {
      const response = await validateFiles(jsonPayload);
      // Check for invalid password response
      if (response === "Invalid Password" || (response && response.message === "Invalid Password") || typeof response === 'undefined') {
        // setOpenDialog(true); // Show the dialog for invalid password
        setShowError(prev => ({ ...prev, [fileControlID]: true }));
        setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false })); // Set correctness to false
        setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));

      } else {
        setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: true })); // Set correctness to true
        setShowError(prev => ({ ...prev, [fileControlID]: false }));
        setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));

        setAllProtectedFiles(prev => prev.filter(file => file.controlId !== fileControlID));
      }
    } catch (error) {
      logger.error("Error unlocking file:", error);
      setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false }));
      setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
      // Optionally, show an error message to the user
    }
  };
  const validateFiles = async (jsonPayload) => {

    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/pending/update`,
        jsonPayload
      );

      return response.data;
    } catch (error) {
      // Handle the error
      logger.error("File validation failed:", error);
    }
  };
  const buildFileStructure = (files) => {
    let structure = { path: "", files: {}, subFolders: {} };

    files.forEach(file => {
      if (!file.filePath) {
        const fileIdentifier = file.fileName + file.controlId;
        structure.files[fileIdentifier] = file;
        return;
      }
      const normalizedPath = file.filePath.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
      const pathParts = normalizedPath.split("/");
      const fileName = pathParts.pop(); // Extract file name
      const fileControlID = file.controlId;
      const fileIdentifier = fileName + fileControlID;

      let currentLevel = structure;
      let currentPath = "";

      pathParts.forEach(folder => {
        currentPath += "/" + folder;
        if (!currentLevel.subFolders[folder]) {
          currentLevel.subFolders[folder] = { path: currentPath, files: {}, subFolders: {} };
        }
        currentLevel = currentLevel.subFolders[folder];
      });

      currentLevel.files[fileIdentifier] = { ...file };
    });
    return structure;
  }
  const filteredData = allProtectedFiles?.filter((item) => {
    const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
    return matchesSearch;
  });
  let fileStructure = buildFileStructure(filteredData);
  const getCurrentFolderContents = () => {
    let currentLevel = fileStructure; // Start from root
    for (const part of currentPath) {
      if (!currentLevel.subFolders[part]) {
        return { subFolders: {}, files: {} }; // Return empty structure if path is invalid
      }
      currentLevel = currentLevel.subFolders[part]; // Navigate deeper
    }
    return currentLevel;
  };
  const hasProtectedFiles = (folderPath, passwordStatus) => {
    const normalizedFilePath = folderPath.startsWith("/") ? folderPath.slice(1) : folderPath;
    const nestedProtectedFiles = filteredData.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      return normalizedFile.startsWith(normalizedFilePath);
    });
    for (const file of nestedProtectedFiles) {
      const status = passwordStatus[file.controlId];
      if (!status) {
        return true; // file is still protected
      }
    }
    return false; // All files password are vaildated
  }
  const getAllFilesRecursively = (folder) => {
    let files = Object.values(folder.files || {});
    for (const sub of Object.values(folder.subFolders || {})) {
      files = files.concat(getAllFilesRecursively(sub));
    }
    return files;
  }
  const isFileValidationInProcess = (folderPath, passwordStatus) => {
    const normalizedFilePath = folderPath.startsWith("/") ? folderPath.slice(1) : folderPath;
    const nestedProtectedFiles = filteredData.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      return normalizedFile.startsWith(normalizedFilePath);
    });
    for (const file of nestedProtectedFiles) {
      const status = showValidatingLoader[file.controlId];
      if (status) {
        return true; // file validation is in process
      }
    }
    return false; // All files validation is completed
  }
  const onPasswordChange = (fileName, newPassword) => {

    setPasswords(prevPasswords => ({
      ...prevPasswords,
      [fileName]: newPassword,
    }));
  };

  const [currentFolderContents, setCurrentFolderContents] = useState(getCurrentFolderContents());
  const handleDeleteSelectedFiles = (allFiles) => {
    const controlIds = allFiles.map(item => item.controlId);
    setSelectedControlIds(controlIds);
    setOpenDeleteDialog(true);
  };

  const handleDeleteFile = (controlId) => {
    // Add file to deleting set immediately when delete is triggered
    setDeletingFiles(prev => new Set([...prev, controlId]));
    
    // Set the control ID to delete and open the confirmation dialog
    setSelectedControlIds([controlId]); // Set the selected control ID for deletion
    setOpenDeleteDialog(true); // Open the delete confirmation dialog
  };
  const handleDeleteDialogClose = () => {
    // Remove files from deleting state if user cancels
    setDeletingFiles(prev => {
      const newSet = new Set(prev);
      selectedControlIds.forEach(id => newSet.delete(id));
      return newSet;
    });
    setSelectedControlIds([]);
    setOpenDeleteDialog(false);
  };
  const confirmDeleteFiles = () => {
    // Add all selected files to deleting set
    setDeletingFiles(prev => new Set([...prev, ...selectedControlIds]));
    
    // Pass the array of control IDs directly
    const controlIdsString = selectedControlIds.join(',');
    handleRemoveFile({
      controlId: controlIdsString, // Pass the array of selected control IDs
      area: rowData?.area,
      noOfDeleteIcon: selectedControlIds.length, // Set the number of delete icons based on selected files
      noOfUploadedFiles: rowData?.noOfUploadedFiles,
      engagementTrackingStatus: rowData?.engagementTrackingStatus,
      engagementId: rowData?.engagementId,
      isPending: true
    });
    setAllProtectedFiles(allProtectedFiles.filter(file => !selectedControlIds.includes(file.controlId)));
    setSelectedControlIds([]); // Clear selected control IDs after deletion
    setOpenDeleteDialog(false); // Close the dialog after confirming
  };
  const countFilesRecursively = (folder) => {
    return Object.keys(folder.files || {}).length +
      Object.values(folder.subFolders || {}).reduce(
        (count, subFolder) => count + countFilesRecursively(subFolder), 0
      );
  };


  const validateProtectedFiles = async () => {
    SetEngLevelValidating(true);

    const jsonPayload = {
      uploadGuid: UPLOADID_GUID,
      engagementGuid: null,
      eng_Password: engLevelPwd,
      engagementId: rowData?.engagementId,
      clientName: rowData?.clientName,
      UserEmailId: getAccount()?.username

    };
    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/upload/validate`,
        jsonPayload
      );
      // SetEngLevelValidating(true);
      startValidationIteration();
    } catch (error) {
      SetEngLevelValidating(false);


    }
  };


  const GetValidationDetails = async () => {
    try {


      const payload = {
        "engagementGuid": null,
        "uploadGuid": UPLOADID_GUID,
      };

      const { data } = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/getValidatedCount`,
        payload
      );

      return data;

    } catch (error) {
      return [];

    }
  };
  const startValidationIteration = async () => {
    let stopped = false;

    const validationStatus = async () => {
      if (stopped) {

        return;
      }

      const data = await GetValidationDetails();

      if (data) {
        if (data[0]?.totalFileValidated > 0) {

          SetengLevelValidationCheck(true);
        }

        SetTotalFiles(data[0]?.totalFiles);
        SetValidateFiles(data[0]?.totalFileValidated);
      }
      const validControlIDs = data
        .filter(file => file.isPasswordValid && (file.validatedStatus === "Password Validated" || file.validatedStatus == "Completed"))
        .map(file => file.controlID);
      if (validControlIDs.length > 0) {

        setAllProtectedFiles(prev =>
          prev.filter(file => !validControlIDs.includes(file.controlId))
        );
      }
      if ((data && (data[0]?.totalFileValidated === data[0]?.totalFiles))) {
        stopped = true;
        SetEngLevelValidating(false);
      }
      const invalidControlIDs = data.filter(
        file =>
          !file.isPasswordValid &&
          (file.validatedStatus === "Password Validated" ||
            file.validatedStatus === "Completed")
      );

      const mappedItems = invalidControlIDs.map(item => ({
        fileName: item.filePath.split("/").pop(),
        filePath: item.filePath,
        controlId: item.controlID, // ensure controlid exists
      }));

      setAllProtectedFiles(prev => {
        // create a set of existing controlIds to check duplicates
        const existingIds = new Set(prev.map(file => Number(file.controlId)));

        // filter out items already in the list
        const newItems = mappedItems.filter(item => !existingIds.has(item.controlId));

        return [...prev, ...newItems];
      });


      const timeoutID = setTimeout(validationStatus, 10000); // poll again after 10 seconds
    };

    validationStatus();
  };

  return (
    <div className="protected-files-display">
      <MotifLabel className='grid-container-inner' >Provide Password <MotifBadge value={allProtectedFiles.length} />  </MotifLabel>

      {allProtectedFiles.length > 0 && <> <MotifFormField className='protected-files-display__form'>

        <MotifLabel className='protected-files-display__label' >Enter common engagement-<br /><span className='protected-files-display__label-two '>level password</span></MotifLabel>
        <MotifFormField
          className="protected-files-display__field"
        >
          <div className="input-with-icon">
            <MotifIcon
              src={passwordCursorIcon}
              className="input-icon"
            ></MotifIcon>
            <MotifInput
              hideClearButton={true}
              onClose={() => { }}
              aria-label="Password"
              placeholder="Password (required)"
              value={engLevelPwd}
              onChange={(e) => { setEngLevelPwd(e.target.value); }}
              type={isEngLevelPasswordVisible ? 'text' : 'password'}
            />
          </div>
          {engLevelPwd.length > 0 && (
            <button className="ft-eng-password-toggle" onClick={() => setIsEngLevelPasswordVisible(!isEngLevelPasswordVisible)}>
              <MotifIcon src={isEngLevelPasswordVisible ? eyeCloseIcon : eyeIcon} />
            </button>
          )}
          {engLevelPwd.length > 0 && <div className='icon-container'>
            {!(engLevelValidating) ? (<div className='check-close-icon' onClick={() => { validateProtectedFiles() }}>
              <MotifIcon src={IconoirCheckIcon} alt='Clear Check Icon' /></div>) : null}
          </div>}

        </MotifFormField>

      </MotifFormField>
        <div className='motif-label grid-container-inner'>
          {engLevelValidating && <div> <SmallCircleLoader /> Validating Files </div>}
          {(!engLevelValidating && engLevelValidationCheck) && <div>Validated {totalValidatedFiles} files out of {totalFiles} </div>}
        </div>
        <div className='search-protected-container'>
          <span className='search-protected-container__label'>Protected files</span>
          <MotifFormField className='search-protected-container__form'>
            <MotifSearch
              aria-label="Search"
              placeholder="Search..."
              value={searchValue}
              onChange={e => setSearchValue(e.target?.value)}
            />
          </MotifFormField>
        </div>
      </>
      }

      <div className="protected-file-list-container">
        {allProtectedFiles.length > 0 && <div className="file-list-breadcrumb" >
          <BreadcrumbNavigation currentPath={currentPath} goBack={goBack} isClientEngagement={isClientEngagement} />
        </div>
        }
        {allProtectedFiles.length == 0 && <div className="file-list-breadcrumb-message" >
          <MotifIcon src={IconoirLockSlash} />
          <MotifLabel> <strong>None of the files require a password </strong></MotifLabel>
          <MotifLabel>You can "Save & Close" to continue</MotifLabel>
        </div>
        }
        <div style={{paddingLeft:'5px'}}>
          {Object.entries(currentFolderContents?.subFolders || {}).map(([name, content]) => {
            const fileCount = countFilesRecursively(content);
            const hasProtectedItems = hasProtectedFiles(content.path, isCorrectPassword);
            const isZip = (name.endsWith(".zip")) ? true : false;
            const isPasswordVisibleForFolder = isPasswordVisible[content.path] ?? false;
            const allFiles = getAllFilesRecursively(content);
            const isValidationInProcess = isFileValidationInProcess(content.path, showValidatingLoader) || engLevelValidating;
              let uploadedBy = "";
                        let latestDate = null;
                        allFiles.forEach(file => {
                          if (file.dateCreated) {
                          const fileDate = new Date(file.dateCreated);
                          if (!latestDate || fileDate > latestDate) {
                            latestDate = fileDate;
                            uploadedBy = file.uploadedBy;
                          }
                          }
                        });

            return (
              <div className="ft-file-item-pending">

                <div className="ft-file-icon-pending  ft-file-icon-protected">
                  <img src={isZip ? require("../../common/images/zip.png") : require("../../common/images/folder.png")} alt={isZip ? "ZIP file icon" : "Folder icon"} />

                </div>
                <div className="ft-file-details">
                  <div className={!hasProtectedItems ? "ft-file-name cursor-pointer ft-grid-passwordProtected" : "ft-file-name cursor-pointer ft-folder-protected ft-grid-passwordProtected"} key={name} title={name}>
                   <div className="ft-file-name-text"> <span className={!hasProtectedItems ? "ft-file-name-text" : "ft-file-name-text ft-folder-protected"} onClick={() => navigateToFolder(name)}>{name}</span>  <div className="ft-file-type "> <span className='spn-file-type-label'>Type:</span> {isZip ? 'ZIP File' : 'Folder'}, {fileCount} Files</div></div>
               <div>
                  {hasProtectedItems && (
                    <div className="ft-file-password-wrapper">
                      <div className="input-container">
                        <MotifInput
                          placeholder="Enter password"
                          className="ft-file-password-input input-container-pendingFiles"
                          onChange={(e) => onPasswordChange(content.path, e.target.value)}
                          value={passwords[content.path] ?? ''}
                          type={isPasswordVisibleForFolder ? 'text' : 'password'}
                          hideClearButton={true}
                        

                        />
                        {passwords[content.path] && (
                          <button className="ft-password-toggle" onClick={() => togglePasswordVisibility(content.path)}>
                            <MotifIcon src={isPasswordVisibleForFolder ? eyeCloseIcon : eyeIcon} />
                          </button>
                        )}
                      </div>
                      <div className="tooltip">
                        {isValidationInProcess ? < div className="pt-file-unlock-circle"> <SmallCircleLoader /> </div> :
                          // <> <button className="pt-file-unlock" onClick={() => handleFolderUnlock(content.path)}>
                          //   <MotifIcon src={checkPwdIcon} />
                          // </button>
                          //   <span className="tooltiptext">Enter a common password to unlock files in this Folder/Zip.</span>
                          // </>
                           <MotifTooltip
                                                                                                 allowClick
                                                                                                 allowHover
                                                                                                 closeButtonProps={{}}
                                                                                                 flip
                                                                                                 id="tooltip"
                                                                                                 placement="auto"
                                                                                                 trigger={
                                                                                                     <MotifIcon
                                                                                                         style={{ marginTop: '6px' }}
                                                                                                         src={checkPwdIcon}
                                                                                                         className="motif-icon-check-pending"
                                                                                                         onClick={() => handleFolderUnlock(content.path)}
                                                                                                     />
                                                                                                 }
                                                                                                 variant="default"
                                                                                             >
                                                                                               Enter a common password to unlock files in this Folder/Zip.
                                                                                             </MotifTooltip>
                        }</div>
                    </div>

                  )

                  }
                  </div>
                  </div>

                   <div className="folder-meta-row">
                                                  <span className="file-meta-value">
                                                    {latestDate
                                                      ? getDateTimeFormat(latestDate) +","
                                                      : ""}
                                                  </span>
                                                  <span className="file-meta-label">
                                                    Uploaded by:
                                                  </span>
                                                  <span className="file-meta-value">
                                                    {getUploadedByFormat(uploadedBy)}
                                                  </span>
                                                </div>
                 
                 
                </div>
                 <div className="ft-file-actions">
                    {hasProtectedItems && (
                      <>
                        <button 
                          className="ft-file-remove ft-file-remove-pendingFiles" 
                          disabled={allFiles.some(file => deletingFiles.has(file.controlId))}
                          onClick={() => handleDeleteSelectedFiles(allFiles)}
                        >
                          {allFiles.some(file => deletingFiles.has(file.controlId)) ? (
                            <SmallCircleLoader color="#ff0000" />
                          ) : (
                            <MotifIcon src={deleteIcon} />
                          )}
                        </button>
                          <button className="ft-file-lock-icon">
                        {!allFiles.some(file => deletingFiles.has(file.controlId)) && (
                        
                                      
                                        <MotifIcon src={lockIcon} className="ft-file-lock-icon" />
                                      
                                    
                          // <MotifIcon src={lockIcon} className="ft-file-lock-icon" />
                        )}
                          </button>
                        
                      </>
                    )}
                  </div>
              </div>

            );
          })}

          {/* Render files */}
          {Object.entries(currentFolderContents?.files || {}).map(([name, file], index) => {
            const fileControlID = file.controlId;
            const isZip = file.fileName.endsWith(".zip");
            return <PendingFileTile
              key={index}
              file={file}
              onPasswordChange={onPasswordChange}
              passwords={passwords}
              handleUnlockFile={handleUnlockFile}
              isCorrectPassword={isCorrectPassword[file.controlId] || false}
              showError={showError[file.controlId] || (engLevelValidationCheck && !engLevelValidating)}
              rowData={rowData}
              isSelected={selectedControlIds.includes(file.controlId)} // Pass selection state
              // onSelectFile={handleSelectFile} // Pass the selection handler
              onDelete={handleDeleteFile} // Pass the delete handler
              providePassword={true}
              showValidatingLoader={showValidatingLoader[file.controlId] || engLevelValidating}
              searchValue={searchValue}
              isDeleting={deletingFiles.has(file.controlId)}
            />;
          })}
        </div>

      </div>


      {/* {allProtectedFiles.length !== 0 && <div className="text-container">
        <span className="ft-normal-small">Your password is encrypted and stored temporarily and will be deleted after processing the files.</span>
      </div>} */}
      <div className="uploader-actions upload-button-container">
        <>

         {allProtectedFiles.length !== 0 && <MotifButton

            variant="secondary"
            onClick={() => {
              triggerEngagementUpdate(rowData.engagementId); onClose();
            }}
          >
            Skip for Now
          </MotifButton>}
          <MotifButton
            variant="primary"
            onClick={() => { triggerEngagementUpdate(rowData.engagementId); onClose(); }}
            disabled={allProtectedFiles.length > 0 && ((!Object.values(isCorrectPassword).some(value => value === true)) || Object.values(showValidatingLoader).some(value => value === true || engLevelValidating))}        >
            Save & Close
          </MotifButton></>
      </div>



      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='deleteDialogBox'
      >
        <DialogTitle>
          <IconButton
            onClick={handleDeleteDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img src={require("../../common/images/warning-triangle.png")} alt={"Note"} />

        </DialogTitle>
        <DialogContent>
          <span id="alert-dialog-description">
            <strong>
              {selectedControlIds.length > 1
                ? "Are you sure you want to permanently delete the selected " + selectedControlIds.length + " files?"
                : "Are you sure you want to permanently delete this file?"}
            </strong>
            <p>This action cannot be undone.</p>
          </span>
        </DialogContent>
        <DialogActions>

          <MotifButton onClick={handleDeleteDialogClose} color="secondary" variant='secondary' >
            Cancel
          </MotifButton>
          <MotifButton onClick={confirmDeleteFiles} color="primary">
            Yes
          </MotifButton>
        </DialogActions>
      </Dialog>
    </div>

  );
};

export default ProtectedFilesDisplay;